export default IconDeviceDesktopExclamation => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-device-desktop-exclamation" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M15 16h-11a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v7" />
  <path d="M7 20h8" />
  <path d="M9 16v4" />
  <path d="M15 16v4" />
  <path d="M19 16v3" />
  <path d="M19 22v.01" />
</svg>`;